import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { type AmcInstanceCreationRequestBody } from "../../../zodios/apiDefinitions/amc";
import { amcInstanceCreationRequestsQueryKey } from "./useAMCInstanceCreationRequest";

/** Asks Amazon for the org's AMC instance with its first advertisers. */
export function useCreateAMCInstanceRequest() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: AmcInstanceCreationRequestBody) => await apiClient.createAMCInstanceCreationRequest(body),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: amcInstanceCreationRequestsQueryKey });
    },
  });
}
